
import { apis } from "service";
import { AxiosRequestConfig } from "axios";
const BASE_URL = 'https://xxl6-bbr3-kxzs.m2.xano.io/api:'
const create_forex_lead = BASE_URL + 'rBHQT4XV/create_forex_lead_v3'

export const createForexLeadApi = async (data: {
    customers_id: number,
    data: {[key: string]: any},
    interaction_id: number,
    reffered_staff_id: number,
    reffered_partner_id: number,
    meeting_staff_id: number[],
    reffered_contacts_id: number,
    meeting_time: number,
    note: string
}): Promise<any> => {
    const config: AxiosRequestConfig = {
        data: data,
    };
    return apis.post(create_forex_lead, config);
}